(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snc-header"]) return;
  try {
    
(function () {

  /* ── ANNOUNCEMENT ROTATOR ── */
  var msgs = document.querySelectorAll('.snc-ann__msg');
  var cur  = 0;
  var paused = false;
  var timer;

  function showMsg(i) {
    msgs.forEach(function(m) { m.classList.remove('snc-ann__msg--on'); });
    cur = ((i % msgs.length) + msgs.length) % msgs.length;
    msgs[cur].classList.add('snc-ann__msg--on');
  }

  function tick() {
    clearInterval(timer);
    if (!paused && msgs.length > 1) {
      timer = setInterval(function(){ showMsg(cur + 1); }, 4000);
    }
  }

  var prev  = document.getElementById('snc-ann-prev');
  var next  = document.getElementById('snc-ann-next');
  var pause = document.getElementById('snc-ann-pause');

  if (msgs.length > 1) {
    if (prev)  prev.addEventListener('click',  function(){ showMsg(cur - 1); tick(); });
    if (next)  next.addEventListener('click',  function(){ showMsg(cur + 1); tick(); });
    if (pause) pause.addEventListener('click', function(){ paused = !paused; tick(); });
    tick();
  }

  /* ── HIDE ANNOUNCEMENT ON SCROLL ── */
  var ann = document.getElementById('snc-ann');
  if (ann) {
    var annHidden = false;
    var annThresholdDown = 80;
    var annThresholdUp  = 20;

    function setAnnState(hide) {
      if (hide === annHidden) return;
      annHidden = hide;
      ann.classList.toggle('snc-ann--hidden', hide);
    }

    function checkAnn() {
      var y = window.scrollY;
      if (!annHidden && y > annThresholdDown) setAnnState(true);
      if (annHidden  && y < annThresholdUp)   setAnnState(false);
    }

    /* Suppress transition on initial render to avoid flash */
    ann.classList.add('snc-ann--no-transition');
    if (window.scrollY > annThresholdDown) ann.classList.add('snc-ann--hidden');
    requestAnimationFrame(function() { ann.classList.remove('snc-ann--no-transition'); });
    annHidden = window.scrollY > annThresholdDown;

    window.addEventListener('scroll', checkAnn, { passive: true });
  }

  /* ── MEGA MENU: CLICK TRIGGER (accesibility + touch) ── */
  document.querySelectorAll('.snc-mi--has-drop .snc-ml').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item   = this.closest('.snc-mi');
      var isOpen = item.classList.contains('snc-mi--open');
      document.querySelectorAll('.snc-mi--open').forEach(function(el){ el.classList.remove('snc-mi--open'); });
      if (!isOpen) item.classList.add('snc-mi--open');
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.snc-mi')) {
      document.querySelectorAll('.snc-mi--open').forEach(function(el){ el.classList.remove('snc-mi--open'); });
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.snc-mi--open').forEach(function(el){ el.classList.remove('snc-mi--open'); });
      closeMob();
    }
  });

  /* ── MOBILE DRAWER ── */
  var mob     = document.getElementById('snc-mob');
  var burger  = document.getElementById('snc-burger');
  var mobClose= document.getElementById('snc-mob-close');
  var mobOv   = document.getElementById('snc-mob-ov');

  function openMob() {
    if (!mob) return;
    mob.classList.add('snc-mob--open');
    mob.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMob() {
    if (!mob) return;
    mob.classList.remove('snc-mob--open');
    mob.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (burger)   burger.addEventListener('click', openMob);
  if (mobClose) mobClose.addEventListener('click', closeMob);
  if (mobOv)    mobOv.addEventListener('click', closeMob);

  /* ── MOBILE ACCORDION ── */
  document.querySelectorAll('.snc-mob__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item   = this.closest('.snc-mob__item');
      var subId  = this.getAttribute('aria-controls');
      var sub    = document.getElementById(subId);
      var isOpen = item.classList.contains('snc-mob__item--open');

      document.querySelectorAll('.snc-mob__item--open').forEach(function(el) {
        el.classList.remove('snc-mob__item--open');
        var s = el.querySelector('.snc-mob__sub');
        if (s) s.hidden = true;
        var b = el.querySelector('.snc-mob__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('snc-mob__item--open');
        if (sub) sub.hidden = false;
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── PREDICTIVE SEARCH ── */
  (function () {
    var wrap    = document.getElementById('snc-search-wrap');
    var input   = document.getElementById('snc-search-input');
    var drop    = document.getElementById('snc-search-dropdown');
    var results = document.getElementById('snc-search-results');
    var allLink = document.getElementById('snc-search-all');
    if (!wrap || !input || !drop) return;

    var debounceTimer, lastQuery = '', activeIndex = -1;

    function formatMoney(cents) {
      // Shopify Predictive Search returns price as integer in centavos (e.g. 15000 = $150.00)
      var n = parseInt(cents, 10);
      if (isNaN(n)) return '';
      return '$' + (n / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function highlight(text, query) {
      if (!query) return text;
      var escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return text.replace(new RegExp('(' + escaped + ')', 'gi'), '<mark>$1</mark>');
    }

    function openDrop() {
      drop.hidden = false;
      wrap.classList.add('snc-search-wrap--open');
      input.setAttribute('aria-expanded', 'true');
    }

    function closeDrop() {
      drop.hidden = true;
      wrap.classList.remove('snc-search-wrap--open');
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function setActive(idx) {
      var items = results.querySelectorAll('.snc-search-result');
      items.forEach(function(el, i) {
        el.classList.toggle('snc-search-result--active', i === idx);
        if (i === idx) el.focus();
      });
      activeIndex = idx;
    }

    function renderSpinner() {
      results.innerHTML = '<div class="snc-search-drop__spinner"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#E0EDD4" stroke-width="2.5"/><path d="M12 3a9 9 0 0 1 9 9" stroke="#3B6D11" stroke-width="2.5" stroke-linecap="round"/></svg></div>';
    }

    function renderResults(products, query) {
      if (!products.length) {
        results.innerHTML = '<p class="snc-search-drop__empty">Sin resultados para "<strong>' + query + '</strong>"</p>';
        return;
      }
      results.innerHTML = products.map(function(p) {
        var imgHtml = p.featured_image
          ? '<img src="' + p.featured_image.url.replace(/(\.\w+)(\?|$)/, '_88x88_crop_center$1$2') + '" alt="" width="44" height="44" class="snc-search-result__img" loading="lazy">'
          : '<div class="snc-search-result__img snc-search-result__img--placeholder"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="3" stroke="#ddd" stroke-width="1.5"/><path d="M3 15l5-5 4 4 3-3 6 6" stroke="#ddd" stroke-width="1.5" stroke-linecap="round"/></svg></div>';
        var price = p.price ? formatMoney(p.price) : '';
        return '<a href="' + p.url + '" class="snc-search-result" role="option" tabindex="-1">'
          + imgHtml
          + '<div class="snc-search-result__info">'
          + '<div class="snc-search-result__title">' + highlight(p.title, query) + '</div>'
          + (p.vendor ? '<div class="snc-search-result__vendor">' + p.vendor + '</div>' : '')
          + '</div>'
          + (price ? '<span class="snc-search-result__price">' + price + '</span>' : '')
          + '</a>';
      }).join('');
    }

    function search(query) {
      if (!query || query.length < 2) { closeDrop(); return; }
      if (query === lastQuery) return;
      lastQuery = query;

      if (allLink) allLink.href = '/search?type=product&q=' + encodeURIComponent(query);

      openDrop();
      renderSpinner();

      fetch('/search/suggest.json?q=' + encodeURIComponent(query)
        + '&resources[type]=product&resources[limit]=6'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,vendor,product_type,variants.title,body,tag')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (input.value.trim() !== query) return; // stale
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products, query);
          activeIndex = -1;
        })
        .catch(function(err) {
          console.error('[SNC Search] fetch error:', err);
          results.innerHTML = '<p class="snc-search-drop__empty">Ocurrió un error. Intenta de nuevo.</p>';
        });
    }

    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var q = this.value.trim();
      if (!q) { closeDrop(); lastQuery = ''; return; }
      debounceTimer = setTimeout(function() { search(q); }, 260);
    });

    input.addEventListener('focus', function() {
      if (this.value.trim().length >= 2) openDrop();
    });

    input.addEventListener('keydown', function(e) {
      var items = results.querySelectorAll('.snc-search-result');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(Math.min(activeIndex + 1, items.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (activeIndex <= 0) { input.focus(); activeIndex = -1; }
        else setActive(activeIndex - 1);
      } else if (e.key === 'Escape') {
        closeDrop(); input.blur();
      }
    });

    results.addEventListener('keydown', function(e) {
      var items = results.querySelectorAll('.snc-search-result');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(Math.min(activeIndex + 1, items.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (activeIndex <= 0) { input.focus(); activeIndex = -1; }
        else setActive(activeIndex - 1);
      } else if (e.key === 'Escape') {
        closeDrop(); input.focus();
      }
    });

    document.addEventListener('click', function(e) {
      if (!wrap.contains(e.target)) closeDrop();
    });
  })();

  /* ── CART BADGE: update on cart changes ── */
  function sncUpdateCartBadge(count) {
    var badges = document.querySelectorAll('[data-snc-cart-count]');
    badges.forEach(function (badge) {
      badge.textContent = count;
      badge.classList.toggle('snc-cart-badge--empty', count === 0);
      badge.classList.add('snc-cart-badge--pop');
      setTimeout(function () { badge.classList.remove('snc-cart-badge--pop'); }, 200);
    });
  }

  // Escucha el evento tras add-to-cart AJAX (cards, carousel y PDP)
  document.addEventListener('snc:cart:updated', function (e) {
    if (e.detail && typeof e.detail.item_count === 'number') {
      sncUpdateCartBadge(e.detail.item_count);
    } else {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { sncUpdateCartBadge(c.item_count); });
    }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snc-plp"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ── FILTER DRAWER ── */
  var fltOpen  = document.getElementById('snc-plp-flt-open');
  var fltClose = document.getElementById('snc-plp-flt-close');
  var fltOv    = document.getElementById('snc-plp-flt-ov');
  var fltDraw  = document.getElementById('snc-plp-flt-drawer');

  function openFlt() {
    if (!fltDraw) return;
    fltOv.classList.add('snc-plp__flt-ov--open');
    requestAnimationFrame(function () {
      fltOv.classList.add('snc-plp__flt-ov--visible');
      fltDraw.classList.add('snc-plp__flt-drawer--open');
    });
    fltDraw.setAttribute('aria-hidden', 'false');
    if (fltOpen) fltOpen.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeFlt() {
    if (!fltDraw) return;
    fltOv.classList.remove('snc-plp__flt-ov--visible');
    fltDraw.classList.remove('snc-plp__flt-drawer--open');
    setTimeout(function () { fltOv.classList.remove('snc-plp__flt-ov--open'); }, 280);
    fltDraw.setAttribute('aria-hidden', 'true');
    if (fltOpen) fltOpen.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (fltOpen)  fltOpen.addEventListener('click', openFlt);
  if (fltClose) fltClose.addEventListener('click', closeFlt);
  if (fltOv)    fltOv.addEventListener('click', closeFlt);

  /* ── SORT BOTTOM SHEET ── */
  var srtOpen  = document.getElementById('snc-plp-sort-open');
  var srtClose = document.getElementById('snc-plp-sort-close');
  var srtOv    = document.getElementById('snc-plp-srt-ov');
  var srtSheet = document.getElementById('snc-plp-sort-sheet');

  function openSrt() {
    if (!srtSheet) return;
    srtOv.classList.add('snc-plp__srt-ov--open');
    requestAnimationFrame(function () {
      srtOv.classList.add('snc-plp__srt-ov--visible');
      srtSheet.classList.add('snc-plp__srt-sheet--open');
    });
    srtSheet.setAttribute('aria-hidden', 'false');
    if (srtOpen) srtOpen.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeSrt() {
    if (!srtSheet) return;
    srtOv.classList.remove('snc-plp__srt-ov--visible');
    srtSheet.classList.remove('snc-plp__srt-sheet--open');
    setTimeout(function () { srtOv.classList.remove('snc-plp__srt-ov--open'); }, 280);
    srtSheet.setAttribute('aria-hidden', 'true');
    if (srtOpen) srtOpen.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (srtOpen)  srtOpen.addEventListener('click', openSrt);
  if (srtClose) srtClose.addEventListener('click', closeSrt);
  if (srtOv)    srtOv.addEventListener('click', closeSrt);

  /* ── ESC KEY closes whichever is open ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeFlt(); closeSrt(); }
  });

  /* ── FILTER GROUP ACCORDION ── */
  document.querySelectorAll('.snc-plp__flt-group-hd').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = this.closest('.snc-plp__flt-group');
      var isClosed = group.classList.contains('snc-plp__flt-group--closed');
      group.classList.toggle('snc-plp__flt-group--closed', !isClosed);
      this.setAttribute('aria-expanded', isClosed ? 'true' : 'false');
    });
  });

})();

/* ── HEADER HEIGHT MEASUREMENT (sets --snc-header-h for fixed toolbar/mob-bar) ── */
(function () {
  function measureHeader() {
    var el = document.getElementById('snc-header-wrap')
          || document.getElementById('header-group')
          || document.querySelector('header');
    if (!el) return;
    var h = el.getBoundingClientRect().height;
    if (h > 0) {
      document.documentElement.style.setProperty('--snc-header-h', h + 'px');
    }
  }

  // ResizeObserver: fires as soon as the header has real dimensions
  var headerEl = document.getElementById('snc-header-wrap')
              || document.getElementById('header-group')
              || document.querySelector('header');
  if (headerEl && window.ResizeObserver) {
    new ResizeObserver(measureHeader).observe(headerEl);
  }

  // Multiple init points to cover different load timings
  requestAnimationFrame(measureHeader);
  if (document.readyState === 'complete') {
    measureHeader();
  } else {
    window.addEventListener('load', measureHeader);
  }

  window.addEventListener('resize', measureHeader, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
